export default __webpack_public_path__ + "static/media/person_banner.cf295096.png";